import { css } from '@emotion/css'
import { spacing, fontSize } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import getThemeColors, { colors } from '../../../themes'

const styles = {
  item: css({
    position: 'relative',
    userSelect: 'none',
    color: colors.blackPearl,
    padding: spacing.default,
    fontSize: fontSize.default,
    cursor: 'pointer',

    '&[disabled]': {
      cursor: 'default',
      pointerEvents: 'none',
      color: colors.geyser,
    },
  }),

  subItem: css({
    display: 'block',
  }),

  icon: css({
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
}

export default styles

export const itemTheme = (theme, selected, focused) => {
  const themed = getThemeColors(theme)
  return css({
    ...(selected && {
      '&:not([disabled])': {
        color: themed.base,
      },
    }),

    '&:focus': {
      outline: 'none',
      backgroundColor: colors.athensGray,
    },

    ...(focused && {
      backgroundColor: themed.light,
      color: themed.base,
    }),
  })
}

export const iconTheme = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}
